// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd9a0205","453":"c3e7f36a","455":"57dc1b41","977":"00cd3986"}[chunkId] + ".chunk.js";
};